<script lang="ts">
    import BackgroundOverlay from './background/background-overlay.svelte';
    import { onDestroy } from 'svelte';
    import { fade } from 'svelte/transition';
    import { portal } from 'svelte-portal';
    import dayjs from 'dayjs';
    import Duration from 'dayjs/plugin/duration';
    import LogoClawbuster from '../../cross-reusable-components/logo/logo-clawbuster.svelte';
    import LogoGame from './logo/logo-game.svelte';
    import ProgressBar from './progress-bar/progress-bar.svelte';
    import { trackEvent } from '@root/src/utils/init-analytics';
    import { gameReady } from '@root/src/store';
    import { EventEmitterInstance } from '@src/utils/event-emitter';

    export let hidden = false;

    let progress = 0;
    let globalLoading;
    let progressTimer;
    let hideTimeout;

    dayjs.extend(Duration);

    const durationStartLoading = dayjs();

    onDestroy(() => {
        cleanListeners();
    });

    const cleanListeners = () => {
        clearInterval(progressTimer);
        clearTimeout(hideTimeout);
        globalLoading?.removeEventListener('transitionend', onTransitionEnd);
    };

    const initLoading = async node => {
        globalLoading = node.parentNode;
        startProgress();
    };

    const onTransitionEnd = () => {
        cleanListeners();
        globalLoading.remove();
    };

    function startProgress() {
        //TODO replace to requestanimation frame
        progressTimer = setInterval(() => {
            progress += Math.floor(Math.random() * 8 + 3);
            if (progress >= 87) {
                clearInterval(progressTimer);
            }
        }, 1000 / 60);
    }

    const onEnd = () => {
        const duration = dayjs.duration(dayjs().diff(durationStartLoading)).asSeconds();
        console.log('total loader screen duration ' + duration);
        trackEvent('game_loading_duration', {
            duration_loading_finish: duration
        });

        gameReady.set(true);
        EventEmitterInstance.emit('game-ready');
        globalLoading.style.opacity = 0;
        globalLoading.style.display = 'none';
        globalLoading.addEventListener('transitionend', onTransitionEnd, {
            once: true,
            passive: true
        });
    };

    $: if (hidden) {
        progress = 100;
        hideTimeout = setTimeout(onEnd, 350);
    }
</script>

{#if !hidden}
    <div use:portal={'#loading-screen'} out:fade|global use:initLoading>
        <BackgroundOverlay />
        <LogoClawbuster
            class="absolute left-1/2 top-4 h-auto w-18 -translate-x-1/2 phone:w-25 tablet:top-5 desktop:top-6"
        />
        <LogoGame class="pointer-events-none mx-auto w-[360px] tablet:w-auto" />
        <ProgressBar progressPercent={progress} />
    </div>
{/if}
